export const getColorByType = (type: string) => {
    const colors: any = {
        badej: '#885200',
        ostatni: '#FFC0CB',
        tvor: '#451C66',
        zazij: '#D64936',
    }
    return colors[type] || '#333333';
}